import { useSelector } from "react-redux";
import { makeStyles, Grid, Typography } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { Icon } from "../../../../../components/base/Icon";
import CloudIcon from "../../../../../assets/images/icons/cloud.svg";
import { VerticalDivider } from "../../../../../components/base/VerticalDivider";
import { currencyFormatter, nKilowattFormatter } from "../../../../../services/utils";

const useStyles = makeStyles((theme) => ({
  item: {
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px ${theme.spacing(2)}px`,
  },
  span: {
    fontWeight: 400,
    fontSize: 18,
  },
}));

export const Overview = ({
  currentProduction,
  installedCapacity,
  accumulatedRevenues,
  accumulatedEmissionSaved,
}) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <Grid container wrap="nowrap">
      <Grid item sm={3} className={classes.item}>
        <Typography variant="body1">Current Production</Typography>
        <Grid container spacing={1}>
          <Grid item>
            <Typography variant="h2">{nKilowattFormatter(currentProduction)}</Typography>
          </Grid>
          <Grid item>
            <Icon src={CloudIcon} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <VerticalDivider containerHeight="100%" color={COLORS.darks[0][10]} />
      </Grid>
      <Grid item sm={3} className={classes.item}>
        <Typography variant="body1">Installed Capacity</Typography>
        <Typography variant="h2">{nKilowattFormatter(installedCapacity)}</Typography>
      </Grid>
      <Grid item>
        <VerticalDivider containerHeight="100%" />
      </Grid>
      <Grid item sm={3} className={classes.item}>
        <Typography variant="body1">Acc. Revenues</Typography>
        <Typography variant="h2">
          {currencyFormatter(accumulatedRevenues, currencySymbol)}
        </Typography>
      </Grid>
      <Grid item>
        <VerticalDivider containerHeight="100%" />
      </Grid>
      <Grid item sm={3} className={classes.item}>
        <Typography variant="body1">Acc. Emission Saved</Typography>
        <Typography variant="h2">
          {accumulatedEmissionSaved} <span className={classes.span}>tCO2</span>
        </Typography>
      </Grid>
    </Grid>
  );
};
